import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#group_svg__a)">
      <path
        fill="#263E6A"
        d="M2.596 18.615V16.97q0-.696.36-1.197.361-.5.97-.8a17 17 0 0 1 2.584-.988q1.283-.369 3.086-.369 1.805 0 3.087.369a17 17 0 0 1 2.583.987q.61.3.97.801t.36 1.197v1.646zm16 0v-1.692q0-.87-.352-1.64a3.8 3.8 0 0 0-.998-1.325q.736.15 1.42.416.681.266 1.35.6.65.326 1.019.836t.369 1.113v1.692zm-9-7.23a2.9 2.9 0 0 1-2.119-.882 2.9 2.9 0 0 1-.88-2.118q0-1.238.88-2.12a2.9 2.9 0 0 1 2.12-.88q1.236 0 2.118.88.88.882.881 2.12 0 1.237-.881 2.118a2.9 2.9 0 0 1-2.119.882m7.27-3q0 1.237-.882 2.118a2.9 2.9 0 0 1-2.119.882q-.063 0-.161-.015-.099-.015-.162-.031a4.66 4.66 0 0 0 1.054-2.957 4.3 4.3 0 0 0-.285-1.56 5.8 5.8 0 0 0-.769-1.391.7.7 0 0 1 .162-.038q.08-.008.161-.008 1.238 0 2.12.88.88.882.88 2.12m-13.27 9.23h12v-.646q0-.352-.176-.615-.176-.264-.632-.504a10.6 10.6 0 0 0-2.36-.916q-1.239-.318-2.832-.319-1.592 0-2.833.319-1.24.318-2.36.916-.455.24-.63.504-.177.262-.177.615zm6-7.23q.825 0 1.413-.588.587-.587.587-1.412t-.587-1.413a1.93 1.93 0 0 0-1.413-.587q-.824 0-1.412.587a1.93 1.93 0 0 0-.588 1.413q0 .824.588 1.412.587.588 1.412.588"
      />
    </g>
    <g clipPath="url(#group_svg__b)">
      <path
        fill="#263E6A"
        d="M50.596 18.615V16.97q0-.696.36-1.197.361-.5.97-.8a17 17 0 0 1 2.584-.988q1.283-.369 3.086-.369 1.804 0 3.087.369 1.282.367 2.584.987.607.3.969.801.36.501.36 1.197v1.646zm16 0v-1.692q0-.87-.352-1.64a3.8 3.8 0 0 0-.998-1.325q.736.15 1.42.416.682.266 1.35.6.649.326 1.019.836t.369 1.113v1.692zm-9-7.23a2.9 2.9 0 0 1-2.119-.882 2.9 2.9 0 0 1-.88-2.118q0-1.238.88-2.12a2.9 2.9 0 0 1 2.12-.88q1.236 0 2.118.88.88.882.881 2.12 0 1.237-.881 2.118a2.9 2.9 0 0 1-2.119.882m7.27-3q0 1.237-.882 2.118a2.9 2.9 0 0 1-2.119.882q-.063 0-.161-.015-.099-.015-.162-.031a4.66 4.66 0 0 0 1.054-2.957 4.3 4.3 0 0 0-.285-1.56 5.8 5.8 0 0 0-.769-1.391.7.7 0 0 1 .162-.038q.081-.008.161-.008 1.238 0 2.12.88.88.882.88 2.12"
      />
    </g>
    <defs>
      <clipPath id="group_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="group_svg__b">
        <path fill="#fff" d="M48 0h24v24H48z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGroup;
